<template>
  <div class="home">
  <div class="header">
    <div class="inner-header">
      <div id="nav">
        <div class="y10a"><span>Y10A</span> Consulting</div>
      </div>
      <div style="display: flex; flexDirection: row; justifyContent: space-around; flexWrap: wrap; padding: 0 5px; paddingTop: 0px;">
        <div style="textAlign: center; marginTop: 80px; marginBottom: 50px;">
          <div style="width: 8em; fontSize: 40px; color: white; fontWeight: 600; letterSpacing: 4px; margin: 0 auto;">THE SWISS ARMY KNIFE FOR YOUR <span style="color: #424242">TECH</span> NEEDS.</div>
        </div>
        <Contact></Contact>
        
      </div>
    </div>
  </div>
  <div class="services">
    <div style="textAlign: center; fontSize: 30px; color: #719DF7; fontWeight: 600;">Our Services</div>
    <div style="display: flex; margin: 0 auto; flexDirection: row; justifyContent: center; marginTop: 40px; flexWrap: wrap; width: 100%;">
      
      <div class="card" v-for="service in services" :key="service.name" style="position: relative;">
          <div v-if="true" class="overlay">
            <i :class="service.icon" style="fontSize: 80px; textAlign: center; color: white; width: 100%; margin: 50px auto;"></i>
          </div>

          <div style="textAlign: center; fontSize: 22px; fontWeight: 900; marginTop: 20px; color: #263238;">{{service.name}}</div>
          <i :class="service.icon" style="fontSize: 80px; textAlign: center; color: #ff7043; width: 100%; margin: 50px auto;"></i>
          <div style="fontWeight: 500; color: grey; textAlign: center; lineHeight: 25px; width: 90%; margin: 0 auto;">
            {{service.description}}
          </div>
      </div>
    </div>
  </div>
  <div class="footer">
    Copyright 2020
  </div>
  </div>
</template>

<script>
import Contact from './Contact.vue';
export default {
  name: 'Home',
  components: {
    'Contact': Contact,

  },
  data() {
    return {
      services: [
        {
          name: "Web Development",
          description: "Forget the boilerplate, one-size-fits-all website solutions out there. Our websites will be tailored to you and your specific needs.",
          icon: "el-icon-cpu"
        },
        {
          name: "Mobile Development",
          description: "We build for iOS and Android.",
          icon: "el-icon-mobile-phone"
        },
        {
          name: "API Development",
          description: "Our API solutions are intuitive, scalable, and secure.",
          icon: "el-icon-set-up"
        },
        {
          name: "Process Automation",
          description: "Are you tired of manual, repetitive processes? Do spreadsheets make your head hurt? We can fix that.",
          icon: "el-icon-setting"
        },
        {
          name: "Cloud Operations",
          description: "We help you leverage the financial and operational efficiencies of the cloud.",
          icon: "el-icon-cloudy"
        },
        {
          name: "Other",
          description: "Tell us what else you need. We'll take care of it.",
          icon: "el-icon-guide"
        }
      ]
    }
  },
  methods: {
    addString() {
      return this.message + "eeee"
    }
  },
  computed: {
    add: function() {
      return this.num + 3
    }
  },
  created: function() {
    
  }

 
}
</script>

<style scoped lang="scss">


@import url('https://fonts.googleapis.com/css2?family=Faustina&family=Lato:wght@900&family=Roboto:wght@500&display=swap');

.services {
  width: 90%;
  padding-top: 40px;
  // background-color: white;
  // height: 500px;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  margin-bottom: 20px;
  // background-color: #90B2F7;
}

.svg {
  color: yellow;
}

.overlay {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background-color: #719DF7;
  overflow: hidden;
  width: 100%;
  height:0;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  transition: 5s ease;
}

// .card:hover .overlay {
//   bottom: 0;
//   height: 100%;
// }

.card:active {
  width: 420px;
  transition: 1s ease;
}

.card {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  margin: 0 20px;
  margin-bottom: 20px;
  background-color: white;
  border-top: 20px solid #719DF7;
  height: 400px;
  width: 370px;
  border-radius: 20px;
}

.card:hover {
  box-shadow: 8px 12px 28px 0 rgba(0,0,0,.1);
  transition: 0.5s;
}

.y10a {
  margin-left: 10vw;
  padding-top: 8px;
  font-family: 'Lato', sans-serif;
  font-size: 35px;
  font-weight: 400;
  // text-shadow: 2px 2px grey;
  color: white;
  opacity: 0.8;
  span {
    opacity: 0.8;
    letter-spacing: 2px;
    font-weight: 600;
    color: white;
  }
}

.y10a:hover {
  opacity: 1;
}

.y10a:hover {
  cursor: pointer;
  color: white;
}

.icon {
  width: 70px;
  height: 70px;
  // color: red;
}

@import url(//fonts.googleapis.com/css?family=Lato:300:400:700);

h2 {
    font-family: 'Lato', sans-serif;
    font-weight: 300;
    font-size: 35px;
}
p {
    font-family: 'Lato', sans-serif;
    letter-spacing: 1px;
    font-size: 14px;
    color: #333333;
}
.header {
    position: relative;
    background: linear-gradient(60deg, rgba(113, 157, 247, 1) 0%, rgba(113, 157, 247, 0.7) 100%);
    color: #f5f5f5;
    height: 500px;
    margin-bottom: 130px;
}

@media (max-width: 750px) {
  .header {
    height: 1000px;
    margin-bottom: 20px;
  }
  .y10a {
    text-align: center;
    margin-left: 0;
  }
}
.inner-header {
    // height: 400px;
    width: 100%;
    padding: 0;
    padding-top: 20px;
}
.waves {
    position: relative;
    width: 100%;
    height: 1vh;
    margin-bottom: -7px;
    /*Fix for safari gap*/
    // min-height: 100px;
    max-height: 100px;
}
.content {
    position: relative;
    height: 20vh;
    text-align: center;
    background-color: white;
}

/* Animation */
.parallax>use {
    animation: move-forever 25s cubic-bezier(.55, .5, .45, .5) infinite;
}
.parallax>use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 20s;
}
.parallax>use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
}
.parallax>use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
}
.parallax>use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
}
@keyframes move-forever {
    0% {
        transform: translate3d(-90px, 0, 0);
    }
    100% {
        transform: translate3d(85px, 0, 0);
    }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
    .waves {
        height: 40px;
        min-height: 40px;
    }
    .content {
        height: 30vh;
    }
    h1 {
        font-size: 24px;
    }
}

.footer {
  height: 20px;
  background-color: #719DF7;
  padding: 10px 10px 5px 5px;
  color: white;
  text-align: right;
  font-size: 12px;
}
</style>
